import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  isDone?: boolean | 0 | null;
}

const CheckmarkMini = ({ isDone, ...props }: Props): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M16.2561 8.27123C16.6034 7.91559 17.1732 7.90881 17.5288 8.25607C17.8844 8.60334 17.8912 9.17314 17.544 9.52878L10.7838 16.4519C10.4074 16.8373 9.7789 16.808 9.44009 16.3891L7.20027 13.6198C6.88769 13.2334 6.94758 12.6667 7.33405 12.3541C7.72051 12.0415 8.28721 12.1014 8.59979 12.4879L10.2031 14.4701L16.2561 8.27123Z"
      fill={isDone ? '#747E8A' : 'white'}
      fillOpacity={isDone ? '1' : '0.1'}
    />
  </svg>
);

export default CheckmarkMini;
